import React, { useCallback, useContext } from 'react';
import NumberFormat from 'react-number-format';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext, useField } from '../FormContext';
import TextFieldView from '../view/TextFieldView';

const TextFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  extendedValidator,
  muiInputProps,
  uiType,
  maxLength,
  ...fieldProps // for future development, know whe have this
}) => {
  const t = useTranslations();
  const { isReadOnlyFieldsEditable } = useContext(FormContext);
  const onValueChange = useCallback(
    e => {
      setValue(e.target.value, e);
    },
    [setValue]
  );

  const validator = useCallback(
    value => {
      value = value || value === 0 ? value : '';
      value += '';
      let error = '';

      if (required && value.trim() === '') {
        error = t('forms.fields.error.required');
      }

      if (extendedValidator) {
        error = extendedValidator(value, error);
      }

      return error;
    },
    [required, extendedValidator]
  );

  useField(internalId, validator);

  let displayValue = value;

  if (readOnly && uiType === 'currency') {
    displayValue = Number(value).toFixed(2);
  } else if (typeof value === 'number') {
    displayValue = value + '';
  }

  const viewProps = {
    internalId,
    value: displayValue,
    onValueChange,
    readOnly,
    mockInput: readOnly && uiType !== 'currency' && !isReadOnlyFieldsEditable,
    muiInputProps,
    maxLength,
    uiType
  };

  return <TextFieldView {...viewProps} />;
};

export default TextFieldEngine;
